import { redactSecrets, SECRET_KEY_RE } from './redact-secrets';

const TARGET_KEYS = [
  'path',
  'filepath',
  'file',
  'url',
  'uri',
  'command',
  'label',
  'media_id',
  'name',
  'target',
] as const;

export const NO_NAMED_TARGET = 'This action has no named target.';

export function namedTarget(args: Record<string, unknown> | null | undefined): string | null {
  if (args == null) return null;
  const redacted = redactSecrets(args) as Record<string, unknown>;
  for (const key of TARGET_KEYS) {
    if (SECRET_KEY_RE.test(key)) continue;
    if (!Object.prototype.hasOwnProperty.call(redacted, key)) continue;
    const value = redacted[key];
    if (typeof value === 'string' || typeof value === 'number') {
      return String(value);
    }
  }
  return null;
}
